export class ListTemplatesAction {
  static type = '[Templates] ListTemplatesAction';
}

export class CreateTemplateAction {
  static type = '[Templates] CreateTemplateAction';
  constructor(public name: string) {}
}

export class CloneTemplateAction {
  static type = '[Templates] CloneTemplateAction';
  constructor(
    public id: string,
    public name: string
  ) {}
}

export class DeactivateTemplateAction {
  static type = '[Templates] DeactivateTemplateAction';
  constructor(public id: string) {}
}

export class ReactivateTemplateAction {
  static type = '[Templates] ReactivateTemplateAction';
  constructor(public id: string) {}
}

export class UpdateTemplateAction {
  static type = '[Templates] UpdateTemplateAction';
  constructor(
    public id: string,
    public name: string
  ) {}
}

export class GetTemplateAction {
  static type = '[Templates] GetTemplateAction';
  constructor(public id: string) {}
}
